import React from 'react';
import { Box } from '@hawkins/components';

export const AppShell = ({ children }: React.PropsWithChildren) => (
  <Box height="100vh" display="flex" flexDirection="column">
    {children}
  </Box>
);
